<div
  class="chips-container"
  #container>
  @for (item of chipsService.chips(); track $index) {
    <app-f-chips-item [item]="item" />
  }

  <div
    class="buttons"
    #buttonsContainer
    [ngClass]="{ overflow: isOverflowWidth() }">
    @if (isOverflowWidth() && !!chipsService.chips().length) {
      <button
        class="show-all"
        (click)="container.classList.toggle('overflow'); buttonsContainer.classList.toggle('overflow')">
        {{ container.classList.contains('overflow') ? 'Show less' : 'Show more' }}
      </button>
    }

    @if (chipsService.chips().length > 1) {
      <button
        class="clear-all"
        (click)="filterService.set({})">
        <mat-icon>delete</mat-icon>
        Remove all
      </button>
    }
  </div>
</div>
